import {defineMessages} from "react-intl";

export const NewTripRequestPageMessages = defineMessages({
  title: {
    id: "newTripRequestPage.title",
    defaultMessage: "Create request",
  },
  publishSuccess: {
    id: "newTripRequestPage.publishSuccess",
    defaultMessage: "The request has been successfully posted.",
  },
  addFlight: {
    id: "newTripRequestPage.addFlight",
    defaultMessage: "Add flight",
  },
  createRequest: {
    id: "newTripRequestPage.createRequest",
    defaultMessage: "Create request",
  },
  oneWay: {
    id: "newTripRequestPage.oneWay",
    defaultMessage: "One Way",
  },
  roundTrip: {
    id: "newTripRequestPage.roundTrip",
    defaultMessage: "Round Trip",
  },
  multiLeg: {
    id: "newTripRequestPage.multiLeg",
    defaultMessage: "Multi Leg",
  },
  noFlightsFound: {
    id: "newTripRequestPage.noFlightsFound",
    defaultMessage: "No flights found",
  },
  requestSubmitted: {
    id: "newTripRequestPage.requestSubmitted",
    defaultMessage: "Request submitted successfully",
  },
  submitError: {
    id: "newTripRequestPage.submitError",
    defaultMessage: "Error submitting request",
  },
})
